export default __webpack_public_path__ + "images/diagnose-garage8883fb344c288cbc99bec2bd63bbeb4f.svg";